import { render, staticRenderFns } from "./ccm-course-list.vue?vue&type=template&id=9af5c84a&"
import script from "./ccm-course-list.vue?vue&type=script&lang=js&"
export * from "./ccm-course-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports